import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"
import _imports_0 from '../assets/img/anab_logo_white.png'


const _hoisted_1 = {
  id: "login",
  class: "w-full h-full"
}
const _hoisted_2 = { class: "fixed anabTeaserText" }
const _hoisted_3 = { class: "subline" }
const _hoisted_4 = { class: "headline" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { id: "loginSidebar" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { for: "email" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "error-msg" }
const _hoisted_11 = { for: "password" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "error-msg" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { for: "email-passwordreset" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "error-msg" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { for: "password" }
const _hoisted_25 = { class: "error-msg" }
const _hoisted_26 = { for: "password" }
const _hoisted_27 = { class: "error-msg" }
const _hoisted_28 = { key: 1 }

import {computed, onMounted, reactive, ref} from 'vue';
import {useGlobalStore} from "@/stores/GlobalStore";
import router from "@/router";
import {useRoute} from "vue-router";
import {notify} from "@kyvg/vue3-notification";
import jwt_decode from "jwt-decode";
import {DisdiStateType, ErrorLocationType, NotifyType, PreferenceType, SsoType} from "@/utilities/enums/Enums";
import TabsWrapper from '@/components/tabs/TabsWrapper.vue';
import TabItem from '@/components/tabs/TabItem.vue';
import {email, helpers, minLength, required, sameAs} from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import {useI18n} from 'vue-i18n';
import Error from "@/components/Error";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {GeneralResponse} from "@/models/api/Responses";
import {i18n} from "@/utilities/i18n/config";
import {UserPreference} from "@/models/user/UserPreference";
import {MiscService} from "@/utilities/services/entities/MiscService";
import {AccountService} from "@/utilities/services/entities/AccountService";
import {UserService} from "@/utilities/services/entities/UserService";
import TextOrSpinner from "@/components/TextOrSpinner";
import {SystemCompanySettings} from "@/models/SystemCompanySettings";
import {PermissionService} from "@/utilities/services/PermissionService";
import {anabPolicies} from "@/AppConfig";
import {usePermissionStore} from "@/stores/PermissionStore";
import OAuthService from "@/utilities/services/OAuthService";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";



export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const { t } = useI18n();
const miscService = new MiscService();
const accountService = new AccountService();
const userService = new UserService();
const permissionService = new PermissionService();

const globalStore = useGlobalStore();
const error = ref(false);
const loading = ref(false);
let activeTab = ref(0);

let token = ref(useRoute().query.token);
let mail = ref(useRoute().query.email);
// let samlBackdoor = ref(useRoute().query.saml);
let passwordResetMailSent = ref(false);

const saveNewPassword = async () => {
  loading.value = true;

  const isFormCorrect = await vPassword$.value.$validate()
  if (!isFormCorrect) {
    // VALIDATOR ERROR
    loading.value = false;
    return
  }

  const resp = await accountService.resetPassword(token.value, mail.value, passwordForm.newPassword, passwordForm.newPasswordRepeat);

  if(resp?.statusCode !== 0) return;

  loading.value = false;

  notify({
    title: "Erfolg",
    text: t('notifications.passwordReset'),
    duration: -1,
    type: NotifyType[NotifyType.success]
  });

  // move back to default tab
  await router.replace("/login");
  activeTab.value = 0;
}

const abortPasswordChange = () => {
  token.value = undefined;
  mail.value = undefined;

  router.replace("/login");
  activeTab.value = 0;
}


onMounted (async ()=>{
  if(token.value !== undefined && mail.value !== undefined) {
    activeTab.value = 1;
  }

  try{
    loading.value = true;
    const startupConfig = await miscService.getStartupConfig(ErrorLocationType.login);
    if (startupConfig === null) {
      loading.value = false;
      return;
    }

    globalStore.settings.defaultHiddenColumns = startupConfig.preferenceInfo;
    globalStore.settings.systemCompanySettings = new SystemCompanySettings(startupConfig.companyName, startupConfig.companyIdCode) ;
    globalStore.settings.startupConfig = startupConfig.startupInfo;
    globalStore.settings.activitySettings = startupConfig.activityInfo;
    globalStore.settings.disdiSettings = startupConfig.disdiInfo;
    globalStore.settings.disdiSettings.disdi = DisdiStateType[startupConfig.disdiInfo.disdi as unknown as keyof typeof DisdiStateType];
    globalStore.settings.enabledFeatures = startupConfig.enabledFeatures;

    // const skipSso = !NullOrUndefinedHelper(samlBackdoor.value) && (samlBackdoor.value as string).toLowerCase() === 'false' //TODO make saml backdoor point at digi3 AzureAD

    if(globalStore.settings.startupConfig.ssoType !== SsoType.none){
      switch (globalStore.settings.startupConfig.ssoType){
        case SsoType.oauth:{
          const clientId = globalStore.settings.startupConfig?.clientId as string;
          const scopes = globalStore.settings.startupConfig?.clientScopes as string;
          const metaDataUrl = globalStore.settings.startupConfig?.metaDataUrl;
          const metaData = !NullOrUndefinedHelper(metaDataUrl) ? await miscService.getOidcMetaData(metaDataUrl as string) : undefined;
          const ssoCallback = "/sso/oAuthCallback";
          const ssoSilentCallback = "/sso/oAuthCallback/silent";

          const oAuthService = new OAuthService(globalStore.getAuthorityUrl(), clientId, scopes, ssoCallback, ssoSilentCallback, metaData);
          await oAuthService.login();
          break;
        }
        case SsoType.saml:{
          window.location.replace(globalStore.getAuthorityUrl());
          break;
        }
      }
    }
  }
  catch (e) {
    console.log("CONFIG LOADING FAILED!", e);
  }

  loading.value = false;
})


const passwordForm = reactive({
  newPassword: '',
  newPasswordRepeat: '',
})
const passwordResetForm = reactive({
  emailreset: '',
})
const form = reactive({
  username: '',
  password: '',
  rememberMe: false
});

const rules = {
  username: {
    required: helpers.withMessage(t('validators.required'), required),
    email: helpers.withMessage(t('validators.email'), email),
  },
  password: {
    required: helpers.withMessage(t('validators.required'), required),
  },
}

const passwordResetRules = {
  emailreset: {
    required: helpers.withMessage(t('validators.required'), required),
    email: helpers.withMessage(t('validators.email'), email),
  },
}
const newPasswordRules = computed(() => {

  const hasNoneAlphaNum = helpers.regex(/\W/);
  const hasNumber = helpers.regex(/\d/);
  const hasUppercaseLetter = helpers.regex(/[A-Z]/);
  const hasLowercaseLetter = helpers.regex(/[a-z]/);

  const rules = {
    newPassword: {
      required: helpers.withMessage(t('validators.required'), required),
      minLength: helpers.withMessage(t('validators.minLength', {amount: 8}), minLength(8)),
      hasNoneAlphaNum: helpers.withMessage(t('validators.hasNoneAlphaNum'), hasNoneAlphaNum),
      hasNumber: helpers.withMessage(t('validators.hasNumber'), hasNumber),
      hasUppercaseLetter: helpers.withMessage(t('validators.hasUppercaseLetter'), hasUppercaseLetter),
      hasLowercaseLetter: helpers.withMessage(t('validators.hasLowercaseLetter'), hasLowercaseLetter),
    },
    newPasswordRepeat: {
      required: helpers.withMessage(t('validators.required'), required),
      sameAsPassword: helpers.withMessage(t('validators.sameAs'), sameAs(passwordForm.newPassword)),
    },
  }
  return rules
})

const v$ = useVuelidate(rules, form)
const vPassword$ = useVuelidate(newPasswordRules, passwordForm)
const vPasswordReset$ = useVuelidate(passwordResetRules, passwordResetForm)

const sendPasswordResetMail = async () => {

  loading.value = true;
  const isFormCorrect = await vPasswordReset$.value.$validate()
  if (!isFormCorrect) {
    // VALIDATOR ERROR
    loading.value = false;
    return
  }

  const resp = await accountService.sendResetPasswordMail(passwordResetForm.emailreset, `${window.location.origin}/login`);

  // sending failed
  if(resp === null || resp === undefined || resp?.statusCode !== 0) {
    loading.value = false;
    return;
  }

  passwordResetMailSent.value = true;
  loading.value = false;
}

const addDynamicRoles= async ()=>{
  const readRoleString = globalStore.settings.disdiSettings?.permissionRead.join(", ");
  const editRoleString = globalStore.settings.disdiSettings?.permissionEdit.join(", ");

  //TODO magic string? better idea?
  permissionService.updateDynamicPolicy("Disdi.Read", readRoleString as string);
  permissionService.updateDynamicPolicy("Disdi.LocationPropertyEdit", editRoleString as string);
}

const onSubmit = async () => {
  loading.value = true;
  const isFormCorrect = await v$.value.$validate();

  if (!isFormCorrect) {
    // VALIDATOR ERROR
    loading.value = false;
    return
  }

  try{
    const resp = await accountService.login(form.username, form.password, form.rememberMe);

    if(resp === null || resp === undefined || resp.statusCode !== 0){
      ErrorHandler.handleError(resp, ErrorLocationType.login);

      loading.value = false;

      return;
    }

    globalStore.setToken(resp.token);

    const user = await userService.getUserById(jwt_decode(resp.token).id, ErrorLocationType.login);

    if(user === null || user === undefined){
      loading.value = false;
      return;
    }

    globalStore.setUser(user);

    // get filters for user
    const filterResp = await userService.getUserPreferences(user.id, PreferenceType.filter);
    // get hiddenColumns for User
    const columnResp = await userService.getUserPreferences(user.id, PreferenceType.hiddenColumn);
    // get general settings for User
    const genSetResp = await userService.getUserPreferences(user.id, PreferenceType.general);
    // get columnOrder settings for User
    const colOrderResp = await userService.getUserPreferences(user.id, PreferenceType.columnOrder);

    if(filterResp?.statusCode === 0 && columnResp?.statusCode === 0 && genSetResp?.statusCode === 0 && colOrderResp?.statusCode === 0) {
      globalStore.setUserPreferences({
        userFilters: filterResp.preferenceInfo ?? [],
        userHiddenColumns: columnResp.preferenceInfo ?? [],
        userColumnOrder: colOrderResp.preferenceInfo ?? [],
        general: {
          darkMode: genSetResp.preferenceInfo.find((pi:UserPreference) => pi.attributeName === "darkMode")?.attributeValue ?? false,
          userStartPage: genSetResp.preferenceInfo.find((pi:UserPreference) => pi.attributeName === "userStartPage")?.attributeValue ?? "/account",
          userLocale: genSetResp.preferenceInfo.find((pi:UserPreference) => pi.attributeName === "userLocale")?.attributeValue ?? "de",
        },
      });

      // set language. if not null or undefined fallback to DE
      // @ts-expect-error
      i18n.global.locale.value = globalStore.userPreferences.general.userLocale;
    }
    else{
      ErrorHandler.handleError(new GeneralResponse(6666, "Ihre Einstellungen konnten nicht geladen werden"), ErrorLocationType.table);

      loading.value = false;
    }

    const notifResp = await miscService.getHubNotifications();

    if(notifResp?.statusCode === 0){
      globalStore.notifications = notifResp.notifications;
    }
    else{
      ErrorHandler.handleError(new GeneralResponse(6667, "Die Benachrichtigungen konnte nicht geladen werden"), ErrorLocationType.table);

      loading.value = false;
    }

    // set new fully set policy array on permission store to make sure it survives page reloads
    const permissionStore = usePermissionStore();
    permissionStore.anabPolicies = anabPolicies;

    await addDynamicRoles();

    // @ts-expect-error
    await router.push(globalStore.userPreferences.general.userStartPage);

    notify({
      title: "Erfolg",
      text: t('login.notifySuccessfulLogin'),
      duration: 5000,
      type: "success"
    });

    loading.value = false;
  }
  catch (e){
    console.log(e);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "fixed anabLogo" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('login.subline')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", null, [
          _createElementVNode("span", {
            innerHTML: _ctx.$t('login.headline')
          }, null, 8, _hoisted_5)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(TabsWrapper, { activeTab: _unref(activeTab) }, {
              default: _withCtx(() => [
                _createVNode(TabItem, {
                  title: _ctx.$t('login.tabs.login.tabTitle')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("form", {
                      onSubmit: _withModifiers(onSubmit, ["prevent"])
                    }, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('login.tabs.login.headline')), 1),
                      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('login.tabs.login.email')), 1),
                      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass({ error: _unref(v$).username.$errors.length })
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          disabled: loading.value,
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.username) = $event)),
                          class: "form-control",
                          placeholder: "E-Mail*",
                          required: "",
                          autocomplete: "email"
                        }, null, 8, _hoisted_9), [
                          [_vModelText, form.username]
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).username.$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-errors",
                            key: error.$uid
                          }, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(error.$message), 1)
                          ]))
                        }), 128))
                      ], 2),
                      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass({ error: _unref(v$).password.$errors.length })
                      }, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('login.tabs.login.password')), 1),
                        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("input", {
                          disabled: loading.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
                          class: "form-control",
                          type: "password",
                          placeholder: "Passwort*",
                          autocomplete: "current-password"
                        }, null, 8, _hoisted_12), [
                          [_vModelText, form.password]
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).password.$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-errors",
                            key: error.$uid
                          }, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(error.$message), 1)
                          ]))
                        }), 128))
                      ], 2),
                      _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_unref(Error), {
                        errorLoc: _unref(ErrorLocationType).login
                      }, null, 8, ["errorLoc"]),
                      _createElementVNode("button", {
                        disabled: loading.value,
                        type: "submit",
                        name: "submit",
                        class: _normalizeClass(["btn", loading.value ? 'disabled' : 'primary'])
                      }, [
                        _createVNode(_unref(TextOrSpinner), {
                          text: _unref(t)('login.tabs.login.submit'),
                          spin: loading.value
                        }, null, 8, ["text", "spin"])
                      ], 10, _hoisted_14)
                    ], 32)
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(TabItem, {
                  title: _ctx.$t('login.tabs.changePassword.tabTitle')
                }, {
                  default: _withCtx(() => [
                    (_unref(token) === undefined || _unref(token) === null || _unref(mail) === undefined || _unref(mail) === null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (!_unref(passwordResetMailSent))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('login.tabs.changePassword.headline')), 1),
                                _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.tabs.changePassword.description')), 1),
                                _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", {
                                  class: _normalizeClass({ error: _unref(vPasswordReset$).emailreset.$errors.length })
                                }, [
                                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('login.tabs.changePassword.email')), 1),
                                  _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    disabled: loading.value,
                                    name: "emailReset",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordResetForm.emailreset) = $event)),
                                    class: "form-control",
                                    type: "text",
                                    placeholder: "E-Mail*",
                                    required: ""
                                  }, null, 8, _hoisted_18), [
                                    [_vModelText, passwordResetForm.emailreset]
                                  ]),
                                  _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vPasswordReset$).emailreset.$errors, (error) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "input-errors",
                                      key: error.$uid
                                    }, [
                                      _createElementVNode("div", _hoisted_19, _toDisplayString(error.$message), 1)
                                    ]))
                                  }), 128))
                                ], 2),
                                _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                _createVNode(_unref(Error), {
                                  errorLoc: _unref(ErrorLocationType).login
                                }, null, 8, ["errorLoc"]),
                                _createElementVNode("button", {
                                  disabled: loading.value,
                                  type: "button",
                                  name: "submit",
                                  class: _normalizeClass(["btn", loading.value ? 'disabled' : 'primary']),
                                  onClick: sendPasswordResetMail
                                }, [
                                  _createVNode(_unref(TextOrSpinner), {
                                    text: _unref(t)('login.tabs.changePassword.submit'),
                                    spin: loading.value
                                  }, null, 8, ["text", "spin"])
                                ], 10, _hoisted_20)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('login.tabs.changePassword.confirmHeadline')), 1),
                                _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.tabs.changePassword.confirmDescription')), 1),
                                _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                                _createVNode(_unref(Error), {
                                  errorLoc: _unref(ErrorLocationType).login
                                }, null, 8, ["errorLoc"]),
                                _createElementVNode("button", {
                                  type: "button",
                                  name: "submit",
                                  class: "btn primary",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(passwordResetMailSent) //@ts-ignore
 ? passwordResetMailSent.value = false : passwordResetMailSent = false))
                                }, _toDisplayString(_ctx.$t('login.tabs.changePassword.confirmButton')), 1)
                              ]))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('login.tabs.changePassword.newPasswordHeadline')), 1),
                          _createElementVNode("div", {
                            innerHTML: _ctx.$t('login.tabs.changePassword.newPasswordDescription')
                          }, null, 8, _hoisted_23),
                          _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("form", null, [
                            _createElementVNode("div", {
                              class: _normalizeClass({ error: _unref(vPassword$).newPassword.$errors.length })
                            }, [
                              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('login.tabs.changePassword.newPasswordLabel')), 1),
                              _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((passwordForm.newPassword) = $event)),
                                class: "form-control",
                                type: "password",
                                placeholder: "Passwort*",
                                autocomplete: "new-password",
                                required: ""
                              }, null, 512), [
                                [_vModelText, passwordForm.newPassword]
                              ]),
                              _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vPassword$).newPassword.$errors, (error) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "input-errors",
                                  key: error.$uid
                                }, [
                                  _createElementVNode("div", _hoisted_25, _toDisplayString(error.$message), 1)
                                ]))
                              }), 128))
                            ], 2),
                            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass({ error: _unref(vPassword$).newPasswordRepeat.$errors.length })
                            }, [
                              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('login.tabs.changePassword.newPasswordRepeatLabel')), 1),
                              _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((passwordForm.newPasswordRepeat) = $event)),
                                class: "form-control",
                                type: "password",
                                placeholder: "Passwort wiederholen*",
                                autocomplete: "new-password",
                                required: ""
                              }, null, 512), [
                                [_vModelText, passwordForm.newPasswordRepeat]
                              ]),
                              _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vPassword$).newPasswordRepeat.$errors, (error) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "input-errors",
                                  key: error.$uid
                                }, [
                                  _createElementVNode("div", _hoisted_27, _toDisplayString(error.$message), 1)
                                ]))
                              }), 128))
                            ], 2),
                            _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                            _createVNode(_unref(Error), {
                              errorLoc: _unref(ErrorLocationType).login
                            }, null, 8, ["errorLoc"]),
                            _createElementVNode("button", {
                              type: "button",
                              name: "submit",
                              class: "btn primary mr-5",
                              onClick: saveNewPassword
                            }, _toDisplayString(_ctx.$t('login.tabs.changePassword.newPasswordSave')), 1),
                            _createElementVNode("button", {
                              type: "button",
                              name: "cancel",
                              class: "btn",
                              onClick: abortPasswordChange
                            }, _toDisplayString(_ctx.$t('login.tabs.changePassword.newPasswordCancel')), 1)
                          ])
                        ]))
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _: 1
            }, 8, ["activeTab"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('login.error.headline')), 1),
            _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.error.description')), 1),
            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
            _createVNode(_unref(Error), {
              errorLoc: _unref(ErrorLocationType).login
            }, null, 8, ["errorLoc"]),
            _createElementVNode("button", {
              type: "submit",
              name: "submit",
              class: "btn primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (error.value = false))
            }, _toDisplayString(_ctx.$t('login.error.button')), 1)
          ]))
    ])
  ]))
}
}

})